<template>
  <div>
    <form>
      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.latkove_nelatkove_zavislosti"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.latkove_nelatkove_zavislosti"
            label="Látkové a nelátkové závislosti"
            name="Látkové a nelátkové závislosti"
            :error-messages="errors.collect('Látkové a nelátkové závislosti')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('latkove_nelatkove_zavislosti')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.sudom_nariadena_liecba"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.sudom_nariadena_liecba"
            label="Súdom nariadená ochranná liečba"
            name="Súdom nariadená ochranná liečba"
            :error-messages="errors.collect('Súdom nariadená ochranná liečba')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('sudom_nariadena_liecba')"
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.absolvovanie_nariadenej_liecby"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.absolvovanie_nariadenej_liecby"
            label="Absolvovanie súdom nariadenej ochrannej liečby"
            name="Absolvovanie súdom nariadenej ochrannej liečby"
            :error-messages="errors.collect('Absolvovanie súdom nariadenej ochrannej liečby')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('absolvovanie_nariadenej_liecby')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.pocet_typov_nariadenej_liecby"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.pocet_typov_nariadenej_liecby"
            label="Počet typov súdom nariadenej ochrannej liečby"
            name="Počet typov súdom nariadenej ochrannej liečby"
            :error-messages="errors.collect('Počet typov súdom nariadenej ochrannej liečby')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('pocet_typov_nariadenej_liecby')"
          />
        </v-flex>
      </v-layout>

      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.prevladajuci_typ_spravanie"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.prevladajuci_typ_spravanie"
            label="Prevládajúci typ správania vo vtos"
            name="Prevládajúci typ správania vo vtos"
            :error-messages="errors.collect('Prevládajúci typ správania vo vtos')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('prevladajuci_typ_spravanie')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-select
            v-model="form.emocionalna_stabilita"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.emocionalna_stabilita"
            label="Emocionálna stabilita (aktuálny stav vo VTOS)"
            name="Emocionálna stabilita (aktuálny stav vo VTOS)"
            :error-messages="errors.collect('Emocionálna stabilita (aktuálny stav vo VTOS)')"
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('emocionalna_stabilita')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.uroven_mentalnych_schopnosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.uroven_mentalnych_schopnosti"
        label="Orientačné určenie pásma úrovne mentálnych schopností"
        name="Orientačné určenie pásma úrovne mentálnych schopností"
        :error-messages="errors.collect('Orientačné určenie pásma úrovne mentálnych schopností')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('uroven_mentalnych_schopnosti')"
      />

      <v-select
        v-model="form.postoj_trestnej_cinnosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.postoj_trestnej_cinnosti"
        label="Postoj k trestnej činnosti"
        name="Postoj k trestnej činnosti"
        :error-messages="errors.collect('Postoj k trestnej činnosti')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('postoj_trestnej_cinnosti')"
      />

      <v-select
        v-model="form.specificka_porucha_osobnosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.specificka_porucha_osobnosti"
        label="Špecifická porucha osobnosti"
        name="Špecifická porucha osobnosti"
        :error-messages="errors.collect('Špecifická porucha osobnosti')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('specificka_porucha_osobnosti')"
      />

      <v-select
        v-model="form.psychoticke_ochorenia"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.psychoticke_ochorenia"
        label="Psychotické ochorenia"
        name="Psychotické ochorenia"
        :error-messages="errors.collect('Psychotické ochorenia')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('psychoticke_ochorenia')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="0"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-toolbar
          dark
          color="indigo"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card>
          <v-card-title>
            <span class="headline">Charakteristika</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.charakteristika"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Zdroj</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.zdroj"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Príklad</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.priklad"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            <span class="headline">Poznámka</span>
          </v-card-title>
          <v-card-text
            v-for="(item, index) in dialog_item.poznamka"
            :key="index"
          >
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: []
    },

    form: {
      id: null,
      latkove_nelatkove_zavislosti: "",
      sudom_nariadena_liecba: "",
      absolvovanie_nariadenej_liecby: "",
      pocet_typov_nariadenej_liecby: "",
      prevladajuci_typ_spravanie: "",
      emocionalna_stabilita: "",
      uroven_mentalnych_schopnosti: "",
      postoj_trestnej_cinnosti: "",
      specificka_porucha_osobnosti: "",
      psychoticke_ochorenia: "",
      expertne_posudenie: "0",
      skore: 0
    },

    craItem: {},

    selects: {
      latkove_nelatkove_zavislosti: [
        "správanie odsúdeného vykazuje znaky závislosti",
        "správanie odsúdeného nevykazuje znaky závislosti"
      ],
      sudom_nariadena_liecba: [
        "odsúdenému bola súdom nariadená ochranná liečba",
        "odsúdenému bola súdom nariadená ochranná liečba opakovane",
        "odsúdenému nebola súdom nariadená ochranná liečba"
      ],
      absolvovanie_nariadenej_liecby: [
        "odsúdený absolvoval súdom nariadený typ/y ochrannej liečby",
        "odsúdený neabsolvoval súdom nariadený typ/y ochrannej liečby",
        "odsúdenému nebola súdom nariadená ochranná liečba"
      ],
      pocet_typov_nariadenej_liecby: [
        "žiadny",
        "1 typ",
        "2 typy",
        "3 typy a viac"
      ],
      prevladajuci_typ_spravanie: ["asertívny", "pasívny", "agresívny"],
      emocionalna_stabilita: [
        "odsúdený je emocionálne stabilný",
        "odsúdený nie je emocionálne stabilný"
      ],
      uroven_mentalnych_schopnosti: [
        "mentálna retardácia",
        "podpriemer",
        "priemer",
        "nadpriemer"
      ],
      postoj_trestnej_cinnosti: [
        "kritický - zodpovednosť voči TČ s vedomím kompetencie meniť svoje správanie / postoje",
        "nekritický - zodpovednosť za TČ odmieta alebo prenáša na ostatných, na okolnosti, cíti sa ako obeť a pod."
      ],
      specificka_porucha_osobnosti: [
        "odsúdený vykazuje znaky špecifickej poruchy osobnosti",
        "odsúdený nevykazuje znaky špecifickej poruchy osobnosti"
      ],
      psychoticke_ochorenia: [
        "odsúdený vykazuje znaky psychotického ochorenia",
        "odsúdený nevykazuje znaky psychotického ochorenia"
      ],
      expertne_posudenie: ["nehodnotené", "malá", "stredná", "vysoká"]
    },

    manual: {
      latkove_nelatkove_zavislosti: {
        nazov: "Látkové a nelátkové závislosti",
        priklad: [
          "1.	správanie odsúdeného vykazujúceho znaky závislosti: Ods. je vo výkone trestu za ekonomickú trestnú činnosť – podvod značného rozsahu. Ako pracovník banky dlhodobo vyberal peniaze z neaktívnych účtov. Začal trpieť chronickými obavami z prezradenia. Úzkosť si navykol tlmiť v práci anxiolytikami, doma alkoholom. Po niekoľkých rokoch začal u seba evidovať rast tolerancie na lieky, z piva prešiel na liehové nápoje. Zo súdnoznaleckého posudku vyplýva, že u menovaného bola diagnostikovaná kombinovaná závislosť a bolo mu súdom nariadené ústavné protialkoholické liečenie. Počas výkonu trestu došlo u neho k zhoršeniu psychického stavu dôsledkom straty sociálneho statusu a odlúčenia od rodiny v smere depresívneho prežívania s verbalizáciou suicidálnych tendencií. Z týchto dôvodov bol hospitalizovaný na psychiatrickom odd. NOaO v Trenčíne. Počas pohovoru sa vyjadril, že sa „necíti byť s alkoholom vysporiadaný“. Vo VVT je to podľa neho len nútená abstinencia. Obáva sa, že po prepustení sa vráti do starých koľají.     Po preštudovaní dostupných materiálov a rozhovore s odsúdeným je zjavné, že napĺňa viaceré znaky závislosti, preto je náležité na túto položku odpovedať kladne.",
          "Pomocná literatúra: Heretik A. a kol.: Klinická psychológia, Psychoprof 2007, s. 342 – 350."
        ],
        charakteristika: ["Expertné posúdenie psychológa."],
        poznamka: [
          "Uvedený bod neznamená, že odsúdený má zdravotníckym pracovníkom diagnostikovanú závislosť - položka „správanie odsúdeného vykazuje znaky závislosti“ sa môže vyznačiť aj u odsúdeného, ktorý nemá diagnostikovanú závislosť."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby -  pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok, ak  je súčasťou spisového materiálu odsúdeného)."
        ]
      },

      sudom_nariadena_liecba: {
        nazov: "Súdom nariadená ochranná liečba",
        priklad: [],
        poznamka: [],
        charakteristika: [
          "Posudzujeme iba súdom nariadené liečby, ak o nich máme vedomosť (aj z minulosti, neposudzujme len aktuálny trest)."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby -  pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok - ak je súčasťou spisového materiálu odsúdeného), rozsudok, psychologický archív, informácie zo zdravotníckeho zariadenia, údaje je možné čerpať aj z informácií získaných zo Vstupného dotazníka pri nástupe do VT."
        ]
      },

      absolvovanie_nariadenej_liecby: {
        nazov: "Absolvovanie súdom nariadenej ochrannej liečby",
        poznamka: [],
        charakteristika: [
          "Myslí sa absolvovanie ochrannej liečby počas aktuálneho výkonu trestu."
        ],
        zdroj: [
          "Aplikácia VVVT - osobná karta č. 3 (preverenie či bol na liečení), ďalšie záznamy, program zaobchádzania."
        ],
        priklad: [
          "Odsúdený má súdom nariadenú ochrannú liečbu, ktorú nestihol absolvovať z organizačných dôvodov a už požiadal o podmienečné prepustenie. V CRA-CR a CRA-RU označíme riadok „odsúdený neabsolvoval súdom nariadenú liečbu“."
        ]
      },

      pocet_typov_nariadenej_liecby: {
        nazov: "Počet typov súdom nariadenej ochrannej liečby",
        priklad: [],
        poznamka: [],
        charakteristika: [
          "Posudzujú sa liečby v aktuálnom VTOS, aj liečby z minulosti, ak o nich máme vedomosť."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby - pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok, ak je súčasťou spisového materiálu odsúdeného).  Údaje je možné čerpať aj z informácií získaných zo Vstupného dotazníka pri nástupe do VT."
        ]
      },

      prevladajuci_typ_spravanie: {
        nazov: "Prevládajúci typ správania vo vtos",
        priklad: [
          "1. ods. s prevládajúcim asertívnym správaním: Ods. A. B. je výkone trestu už 3 roky, je to jeho druhý výkon trestu OS. Počas tejto doby je jeho správanie bez výrazných anomálií, nebol disciplinárne potrestaný, má 2 disciplinárne odmeny. Bol zaradený do práce, pracoval na dvoch pracoviskách, jedno typu Ndh, pracovné úlohy si plnil primerane. Pedagóg konštatoval, že ods. dlhodobo plní program zaobchádzania. Pri rozhovoroch s ním ako aj s ostatným personálom ods. reaguje primerane, vie si priznať chybu.",
          "2. ods. s prevládajúcim agresívnym správaním: Ods. A. C. je vo výkone trestu piatykrát, aktuálne za lúpežné prepadnutie, predtým ublíženie na zdraví, krádež, domáce násilie. Počas výkonu trestu bol 4x disciplinárne potrestaný – fyzicky napadol spoluodsúdeného, verbálne osočoval referenta režimu, úderom poškodil dvere na ubytovni, odmietol splniť pokyn príslušníka. Výkon trestu začal v B diferenčnej skupine, aktuálne je v C DS pričom program zaobchádzania sa plní len čiastočne. Pri pohovoroch s pedagógom zvykne svoje názory obhajovať krikom, prudko gestikuluje, skáče do reči, verbalizuje nespokojnosť s väzenskými pravidlami, o iných odsúdených sa vyjadruje s dešpektom, vulgarizmami. Z práce vo VT bol vyradený, pretože sa pohádal s majstrom, ktorý sa podľa neho do roboty s drevom nerozumie ani za mak.",
          "3.	ods. s prevládajúcim pasívnym správaním: Ods. A. D. je vo výkone trestu prvýkrát za drobné krádeže. Podľa psychologického vyšetrenia žil pred výkonom trestu bezdomoveckým spôsobom, nadužíval alkohol, sporadicky užíval drogy. Je rozvedený, s manželkou ani rodinnými príslušníkmi neudržiava kontakt. Počas výkonu trestu dlhodobo nepracoval – po 2 týždňoch bol z práce vyradený pre nedostatočný pracovný výkon – cíti to ako krivdu,  „iní robili ešte menej a tam sú“. Pri pohovoroch s pedagógom ventiluje pocit, že je obeťou zlých rodinných vzťahov – brat ho okradol o rodičovský dom, manželka sa s ním večne hádala, nemal pri nej priestor na svoje záľuby. Do budúcnosti sa hľadí pesimisticky („v tejto republike zdochol pes“). Vyjadruje pocity skleslosti a nudy. V societe odsúdených na ubytovni obsadzuje najnižšie statusové pozície. Je podozrenie, že ho šikanujú spoluodsúdení - využívajú ho na drobné služby.",
          "Pomocná literatúra: Novák T., Capponi V.: Asertivně do života, Grada 2012."
        ],
        poznamka: [],
        charakteristika: ["Psychológ vychádza z teórie asertivity."],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby - pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok - ak je súčasťou spisového materiálu odsúdeného)."
        ]
      },

      emocionalna_stabilita: {
        nazov: "Emocionálna stabilita (aktuálny stav vo VTOS)",
        priklad: [],
        poznamka: [],
        charakteristika: [
          "Emocionálnou stabilitou rozumieme schopnosť  primerane spracovávať vonkajšie aj vnútorné podnety (bez zvýšenej  iritability, konfliktnosti, vzťahovačnosti a pod.)"
        ],
        zdroj: [
          "Psychológ hodnotí emočnú stabilitu odsúdeného od začiatku obmedzenia osobnej slobody (pobyt vo VV, VTOS)  až po aktuálny stav na základe záznamov a poznatkov o odsúdenom od personálu."
        ]
      },

      uroven_mentalnych_schopnosti: {
        nazov: "Orientačné určenie pásma úrovne mentálnych schopností",
        charakteristika: [],
        priklad: [],
        poznamka: [],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby - pozorovanie odsúdeného, prípadne aktuálne expertné posúdenie psychológa."
        ]
      },

      postoj_trestnej_cinnosti: {
        nazov: "Postoj k trestnej činnosti",
        priklad: [
          "Odsúdený je nekritický voči trestnému činu: Ods. P. R. je vo výkone trestu ôsmykrát, aktuálne za krádež tovaru, za ktorý dostal od dílera  drogy, súčasne obvinený z lúpežného prepadnutie bývalej priateľky, predtým nebezpečné vyhrážanie, krádeže, výtržníctvo. Z predchádzajúcich psychologických vyšetrení a dostupných informácií má veľmi dobrú orientáciu v podmienkach VV resp. VTOS a svoje správanie vie účelovo prispôsobovať požiadavkám okolia a manipuláciami dosahovať výhody. Jeho postoj k trestnej činnosti je zdanlivo kritický, nakoľko skutok popisuje v zhode so spisovým materiálom (rozsudok) a vyjadruje ľútosť nad skutkom a aj nad svojou trestnou činnosťou v minulosti, no pri podrobnejšom popise činu vystupuje do popredia egocentrický a sebavyviňovací rozmer: „...to bolo ešte keď som drogoval, to som bol pod vplyvom, robil som to pre dávku...“; „...to nebolo vyhrážanie, frajerka si našla iného, tak som jej to chcel vykričať a jemu vysvetliť, čo to znamená prebrať inému dievča, ...oľutoval som to a teraz si musím vytrpieť trest...“."
        ],
        poznamka: [],
        charakteristika: [
          "Nemusí sa zhodovať s položkou 2 d („prijatie zodpovednosti za páchanú trestnú činnosť“ -  hodnotí pedagóg). Predpokladá sa analýza aktuálnej trestnej činnosti odsúdeného (spracovanie motívu trestného činu bez egocentrického obsahu, schopnosť popísať zážitok obete, schopnosť reálnej empatie voči obetiam a sociálnemu prostrediu). Je predpoklad veľmi malého počtu odsúdených kritických voči TČ s uvedomením si zodpovednosti za svoje správanie a postoje, ktoré k TČ viedli a schopností meniť ich."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby - pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok, ak je súčasťou spisového materiálu odsúdeného)."
        ]
      },

      specificka_porucha_osobnosti: {
        nazov: "Špecifická porucha osobnosti",
        priklad: [
          "Odsúdený vykazujúci znaky špecifickej poruchy osobnosti (v tomto prípade disociálnej poruchy osobnosti): Ods. A.D. podľa poznatkov z psychologického vyšetrenia od detstva kradol, klamal, chodieval poza školu, spoluvytváral asociálnu partiu rovesníkov, nevychádzal dobre s matkou ani s otčimom, mal problémy rešpektovať učiteľov. Jeho správanie v dospelosti sa vyznačuje páchaním rôznej trestnej činnosti, udržiava len krátke erotické vzťahy, k iným pristupuje často so zníženou empatiou. Ďalej bolo zistené, že odsúdený má nízku frustračnú toleranciu a sklony k výbuchom agresivity a násiliu. Chýba mu súcit. Je ľahostajný voči spoločenským normám. Má nedostatočné citové prežívanie a o druhých javí chladný nezáujem. Za svoje prehry viní sociálne okolie. Vo výkone testu je desiatykrát, aktuálne za sériové vykrádanie domov počas neprítomnosti majiteľa. Počas výkonu trestu (3 roky) bol vždy zaradený do diferenciačnej skupiny C, program zaobchádzania sa neplní. Pedagógom je charakterizovaný ako dominantný konfliktný jedinec, ktorý nerešpektuje autority, koná len vo svoj prospech. Bol viackrát disciplinárne potrestaný. Účelovo sa sebapoškodil. Netají sa tým, že po VT sa bude venovať trestnej činnosti, teraz si to už ale lepšie premyslí a nedá sa chytiť. Po preštudovaní dostupných materiálov a rozhovore s odsúdeným je zjavné, že napĺňa viaceré kritériá pre (disociálnu) poruchu osobnosti podľa MKCH-10, preto je náležité na túto položku odpovedať kladne.",
          "Pomocná literatúra: Praško J. a kol.: Poruchy osobnosti, Portál 2015, s. 201 – 340."
        ],
        charakteristika: ["Expertné posúdenie psychológa."],
        poznamka: [
          "Uvedený bod neznamená, že odsúdený má zdravotníckym pracovníkom diagnostikovanú poruchu osobnosti - položka „odsúdený vykazuje znaky špecifickej poruchy osobnosti“ sa môže vyznačiť aj u odsúdeného, ktorý nemá diagnostikovanú poruchu osobnosti."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby - pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok, ak je súčasťou spisového materiálu odsúdeného)."
        ]
      },

      psychoticke_ochorenia: {
        nazov: "Psychotické ochorenia",
        priklad: [
          "Odsúdený vykazujúci znaky psychotického ochorenia: Ods. A.E. má 28 rokov, podľa poznatkov so psychologického vyšetrenia bol pred 7 rokmi niekoľko mesiacov hospitalizovaný na psychiatrickom odd. Nemocnice v Záluží. Diagnózu nevie uviesť, bolievala ho hlava, hneval sa na niektorých ľudí vo svojom okolí. Aktuálne poberá čiastočný invalidný dôchodok „na hlavu“, dlhodobo užíva psychofarmaká zo skupiny antipsychotík (Haloperidol a i.). V súdno-znaleckom posudku je hodnotený ako paranoidný schizofrenik. Ods. spáchal lúpež, vytrhol dôchodkyni na ulici mobil z ruky a následne ho predal. Počas výkonu väzby vyžadoval niekoľkonásobné intervencie zo strany lekára, psychiatra a psychológa. Upodozrieval spoluodsúdených ne cele, že mu kradnú veci. Lekára obviňoval z toho, že mu  do brušnej dutiny nainštaloval odpočúvacie zariadenie značky Hanyo, bolieva ho preto žalúdok..  Počas celého výkonu trestu mu bola pridelená diferenciačná skupina OŠZ o bol umiestnený v príslušnom oddiele. Bol mu stanovený program intenzívnej liečebno-výchovnej starostlivosti, zúčastňoval sa arteterapeutických aktivít. Pedagógom bol hodnotený ako uzavretý,  citovo plochý a tichý. Pretrvávajú u neho bludné konštrukty (pohovory s pedagógom, psychológom a referentom režimu), že ústavné jedlo je kontaminované, aby bol ľahko ovládateľný a bludná predstava o odpočúvacích prístrojoch do neho chirurgicky vložených. Po preštudovaní dostupných materiálov a rozhovore s odsúdeným je zjavné, že napĺňa viaceré kritériá pre psychotické ochorenie (paranoidnú schizofréniu) podľa MKCH-10, preto je náležité na túto položku odpovedať kladne.",
          "Pomocná literatúra:  Pavlovský P. a kol.: Soudní psychiatrie a psychologie, Grada 2012. Heretik A. a kol.: Klinická psychológia, Psychoprof 2007, s. 265 – 293."
        ],
        charakteristika: ["Expertné posúdenie psychológa."],
        poznamka: [
          "Uvedený bod neznamená, že odsúdený má zdravotníckym pracovníkom diagnostikované psychotické ochorenie - položka „odsúdený vykazuje znaky psychotického ochorenia“ sa môže vyznačiť aj u odsúdeného, ktorý nemá diagnostikované psychotické ochorenie."
        ],
        zdroj: [
          "Aplikácia VVVT - ďalšie záznamy - psychologické vyšetrenia a služby - pozorovanie odsúdeného, zahŕňa aj štúdium spisového materiálu (súdnoznalecký posudok, ak je súčasťou spisového materiálu odsúdeného)."
        ]
      },

      expertne_posudenie: {
        nazov:
          "Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa dopustí trestnej činnosti do 2 rokov od prepustenia",
        priklad: [],
        poznamka: [],
        zdroj: [],
        charakteristika: [
          "Expertné posúdenie znamená komplexné hodnotenie, ktoré je založené na teoretických znalostiach a praktických skúsenostiach hodnotiteľa – poskytuje odpoveď na otázku „Aká je z Vášho profesionálneho pohľadu na odsúdeného pravdepodobnosť jeho opakovaného zlyhania (trestnej činnosti) v najbližších dvoch rokoch?“"
        ]
      }
    }
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    }
  },

  created() {
    this.getPsychologickeVysetrenie();
  },

  methods: {
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    clear() {
      this.form.id = null;
      this.form.latkove_nelatkove_zavislosti = "";
      this.form.sudom_nariadena_liecba = "";
      this.form.absolvovanie_nariadenej_liecby = "";
      this.form.pocet_typov_nariadenej_liecby = "";
      this.form.prevladajuci_typ_spravanie = "";
      this.form.emocionalna_stabilita = "";
      this.form.uroven_mentalnych_schopnosti = "";
      this.form.postoj_trestnej_cinnosti = "";
      this.form.specificka_porucha_osobnosti = "";
      this.form.psychoticke_ochorenia = "";
      this.form.expertne_posudenie = "nehodnotené";
      this.skore = 0;
    },
    getPsychologickeVysetrenie() {
      apiService
        .getPsychologickeVysetrenie(this.$route.params.id)
        .then(response => {
          this.form = response;
        });
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.craItem = response;
      });
    },
    updateItem() {
      apiService
        .updatePsychologickeVysetrenie(this.form, this.$route.params.id)
        .then(
          () => {
            this.snackbar_saved = true;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    openItem() {
      apiService
        .updatePsychologickeVysetrenie(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          response => {
            this.snackbar_saved = true;
            this.form = response;
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updatePsychologickeVysetrenie(this.form, this.$route.params.id)
              .then(
                response => {
                  this.snackbar_saved = true;
                  this.form = response;
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    }
  }
};
</script>